/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_ImagenActa as ImagenActa,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_Q1_81_49(e) {
  let t = (0, ReactCompiler.c)(15),
    { acta: n, campo: r, alto: i } = e,
    a = i === void 0 ? `h-20` : i,
    o = n.archivos,
    s,
    c,
    l;
  if (t[0] !== n.archivos || t[1] !== n.id || t[2] !== a || t[3] !== r) {
    l = Symbol.for(`react.early_return_sentinel`);
    bb0: {
      let e;
      t[7] === r
        ? (e = t[8])
        : ((e = (e) => !r || e.campo === r), (t[7] = r), (t[8] = e));
      let i = o.filter(e);
      if (!i.length) {
        l = null;
        break bb0;
      }
      s = `grid grid-cols-3 gap-2 sm:grid-cols-4`;
      let u;
      (t[9] !== n.id || t[10] !== a
        ? ((u = (e) => (
            <ImagenActa key={e.id} actaId={n.id} archivo={e} alto={a} />
          )),
          (t[9] = n.id),
          (t[10] = a),
          (t[11] = u))
        : (u = t[11]),
        (c = i.map(u)));
    }
    ((t[0] = n.archivos),
      (t[1] = n.id),
      (t[2] = a),
      (t[3] = r),
      (t[4] = s),
      (t[5] = c),
      (t[6] = l));
  } else ((s = t[4]), (c = t[5]), (l = t[6]));
  if (l !== Symbol.for(`react.early_return_sentinel`)) return l;
  let u;
  return (
    t[12] !== s || t[13] !== c
      ? ((u = <div className={s} children={c} />),
        (t[12] = s),
        (t[13] = c),
        (t[14] = u))
      : (u = t[14]),
    u
  );
}
